import type { IPromotionRepository } from '../repositories/IPromotionRepository.js';

export interface ExistsPromotionByCodeUseCaseDeps {
  promotionRepository: IPromotionRepository;
}

export const createExistsPromotionByCodeUseCase = ({ promotionRepository }: ExistsPromotionByCodeUseCaseDeps) => {
  return async (projectId: string, code: string, excludeId?: string): Promise<boolean> => {
    return promotionRepository.existsByCode(projectId, code, excludeId);
  };
};
